module.exports = __webpack_public_path__ + "img/zc5.2fec0ed1.png";